import React from 'react'
import { actionsType } from 'config/constants'
import Drawer from 'components/Drawers/Drawer'
import MiniCartContainer from 'containers/MiniCart'
import MiniCartContent from 'components/Drawers/DrawerMiniCart/MiniCartContent'
import style from './style.scss' //NOSONAR
import PubSub from 'services/PubSub'

let actions = []

const DrawerMiniCart = () => {
    const [orderForm, setOrderForm] = React.useState()

    React.useEffect(() => {
        PubSub.register(actionsType.DRAWER.MINICART_OPEN, open)

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, [])

    const open = (payload) => {
        setOrderForm(payload?.value?.orderForm)
    }

    return (
        <Drawer
            customClass={'drawer-minicart'}
            actionOpen={actionsType.DRAWER.MINICART_OPEN}
            actionClose={actionsType.DRAWER.MINICART_CLOSE}>
            <MiniCartContainer orderForm={orderForm} >
                {(propsComponent) => {
                    return <MiniCartContent {...propsComponent} />
                }}
            </MiniCartContainer>
        </Drawer>
    )
}

export default DrawerMiniCart
